import {Text} from 'common/text'
import {useTranslation} from "react-i18next";
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";

export const FacebookMessageConfirmOrderEmpty = ({...props}) => {
  const {data, methods} = useFacebookMessageConfirmOrder()
    const {t} = useTranslation()
  return (
    <div
      {...props}
      style={{
        height: 'calc(100vh - 340px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text
        as="div"
        color="#7C88A6"
        fontWeight={600}
        style={{marginBottom: 4, textAlign: 'center'}}
      >
        {!!data.filter.keyword.trim()
          ? t('facebookManagement_noResult')
          : t('facebookManagement_noFeedback')}
      </Text>
      <Text
        as="div"
        color="#7C88A6"
        style={{marginBottom: 16, textAlign: 'center'}}
      >
          {t('facebookManagement_setupFeedback')}
      </Text>
    </div>
  )
}
